import PostAPI from '@/app/apis/main/post/post-api.js';

export default {
	/**
	 * @param {*} postDetails
	 * @returns {Promise}
	 */
	async createPost(postDetails) {
		return PostAPI.createPost(postDetails);
	},

	/**
	 * @param {Number} postId
	 * @returns {Promise}
	 */
	async getPostById(postId) {
		return PostAPI.getPostById(postId);
	},

	/**
	 * @param {*} options
	 * @returns {Promise}
	 */
	async getPosts(options) {
		return PostAPI.getPosts(options);
	},

	/**
	 * @param {Number} postId
	 * @returns {Promise}
	 */
	async deletePost(postId) {
		return PostAPI.deletePost(postId);
	},

	async updatePost(postDetails) {
		return PostAPI.updatePost(postDetails);
	}
}